var _style, _path, _g, _line;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMailPrint = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    focusable: "false",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{fill:none;stroke:#13ADCE !important;stroke-width:20;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480.3,345.5v-59.7c0-4.4-1.8-8.6-4.9-11.8l-23.5-23.6c-3.1-3.1-7.3-4.9-11.8-4.9H297.2 c-9.2,0-16.6,7.4-16.6,16.6v83.2c-18.4,0-33.3,14.9-33.3,33.3v58.3c0,4.6,3.7,8.3,8.3,8.3h25v49.9c0,9.2,7.4,16.6,16.6,16.6h166.5 c9.2,0,16.6-7.4,16.6-16.6v-49.9h25c4.6,0,8.3-3.7,8.3-8.3v-58.3C513.6,360.4,498.7,345.5,480.3,345.5z M447,478.7H313.8v-49.9H447 V478.7z M447,362.2H313.8V279h99.9v25c0,4.6,3.7,8.3,8.3,8.3h25V362.2z M472,399.6c-6.9,0-12.5-5.6-12.5-12.5 c0-6.9,5.6-12.5,12.5-12.5s12.5,5.6,12.5,12.5S478.9,399.6,472,399.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.9,24.3C0.5,24,0.3,23.7,0,23.3v147.9c0.3-0.3,0.6-0.6,0.9-0.9l75.6-72.9L0.9,24.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.8,80.9l15.8,15.2l15.5,15c6.5,6.3,15.4,9.7,24.6,9.7c9.1,0,18.1-3.3,24.6-9.7l13.1-12.6L208,83.3 l77.7-74.9c3.7-3.5,5.6-6.6,6.4-8.4H16.1c1.1,1.7,2.6,3.6,5,5.9L98.8,80.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,113.5l-15.2,14.7c-10.8,10.4-24.6,15.3-38.2,15.3c-13.7,0-27.4-4.9-38.2-15.3l-17.6-16.9L21,186.2 c-3.8,3.7-5.7,6.8-6.5,8.4h276.2c-1.1-1.7-2.6-3.7-5-6L208,113.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.3,25.5l-75.6,72.9l75.6,73.1c0.3,0.4,0.6,0.6,0.9,0.9V24.5C299.9,24.9,299.6,25.2,299.3,25.5z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 0,
    y1: 512,
    x2: 512,
    y2: 0
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMailPrint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mail_print.ea06f0a8.svg";
export { ForwardRef as ReactComponent };